import { useState } from "react";
import { toast } from "react-toastify";
import dataService from "../../../helpers/dataService";

// Statuts d'envoi possibles
export const STATUTS_ENVOI = {
  A_TRAITER: "A_TRAITER",
  EN_COURS: "EN_COURS",
  ENVOYE: "ENVOYE",
  ERREUR: "ERREUR",
};

const useRDOInviteList = () => {
  const initialSearchState = {
    filters: {
      terms: "",
      statut: "",
      numeroLot: "",
      dateEnvoiDebut: "",
      dateEnvoiFin: "",
      orientationAvantRDO: "",
      orientationApresRDO: "",
    },
    page: 1,
    nbItemsByPage: 25,
  };

  const [invitations, setInvitations] = useState([]);
  const [search, setSearch] = useState(initialSearchState);
  const [isLoading, setIsLoading] = useState(false);
  const [nbPages, setNbPages] = useState(1);
  const [nbResults, setNbResults] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);

  // Charger les invitations
  const searchInvitations = (
    pagi = false,
    nbi = false,
    customSearch = null
  ) => {
    setIsLoading(true);
    setHasSearched(true);

    const baseSearch = customSearch || search;
    const searchParams = {
      ...baseSearch,
      page: pagi || baseSearch.page,
      nbItemsByPage: nbi || baseSearch.nbItemsByPage,
    };

    dataService.post(
      "rdo/relances/chercher",
      searchParams,
      (result) => {
        setInvitations(result.data);
        // setInvitations([
        //   {
        //     id: "677b9a6b127f64001de8f0e1",
        //     nom: "Drula",
        //     prenom: "Médérick",
        //     nir: "199069741102608",
        //     dateNaissance: "1984-11-12T00:00:00.000Z",
        //     email: "romain+test3@10positif.com",
        //     model: "UserRecipient",
        //     statut: "ENVOYE",
        //     nomAgent: "Romain Grau",
        //     numeroLot: "LOT-25-10-27-1",
        //     orientationApresRDO: "CAF",
        //     dateOrientationApresRDO: "2025-11-04T12:10:19.378Z",
        //     orientationApresRelanceRdoEstUnMaintien: false,
        //     dateCompletionRDO: "2025-11-04T12:09:08.528Z",
        //     dateEnvoi: "2025-10-27T14:27:30.806Z",
        //   },
        //   {
        //     id: "6773cfc07cdcd6001c53cdaf",
        //     nom: "ROBERT",
        //     prenom: "MARIE",
        //     nir: "258019741206968",
        //     matricule: 305274,
        //     dateNaissance: "1958-01-11T20:00:00.000Z",
        //     email: "romain+test251021@10positif.com",
        //     model: "UserRecipient",
        //     statut: "ENVOYE",
        //     nomAgent: "Romain Grau",
        //     numeroLot: "LOT-25-10-14-1",
        //     orientationAvantRDO: "Conseil départemental",
        //     dateOrientationAvantRDO: "2025-01-20T19:06:28.490Z",
        //     orientationApresRDO: "Conseil départemental",
        //     dateOrientationApresRDO: "2025-11-04T14:15:26.783Z",
        //     orientationApresRelanceRdoEstUnMaintien: true,
        //     dateCompletionRDO: "2025-11-04T12:48:41.330Z",
        //     dateEnvoi: "2025-10-21T05:12:06.172Z",
        //   },
        //   {
        //     id: "690b0eacc4498c6f860ccd0c",
        //     nom: "SILEZA",
        //     prenom: "Mary",
        //     nir: "257059939021064",
        //     matricule: 321511,
        //     dateNaissance: "1957-05-23T20:00:00.000Z",
        //     email: "romain+test251021_2@10positif.com",
        //     model: "UserRecipient",
        //     statut: "ENVOYE",
        //     nomAgent: "Romain Grau",
        //     numeroLot: "LOT-25-10-14-1",
        //     orientationAvantRDO: "France Travail",
        //     dateOrientationAvantRDO: "2014-05-27T20:00:00.000Z",
        //     orientationApresRDO: "Conseil départemental",
        //     dateOrientationApresRDO: "2025-11-05T08:46:34.429Z",
        //     orientationApresRelanceRdoEstUnMaintien: false,
        //     dateCompletionRDO: "2025-11-05T08:46:34.304Z",
        //     dateEnvoi: "2025-11-05T08:45:32.482Z",
        //   },
        // ]);
        setNbPages(Math.ceil(result.count / searchParams.nbItemsByPage));
        setNbResults(result.count);
        setIsLoading(false);
      },
      (error) => {
        toast.error("Erreur lors du chargement des invitations");
        setInvitations([]);
        setIsLoading(false);
      },
      () => setIsLoading(false)
    );
  };

  // Mettre à jour les filtres
  const updateSearch = (e) => {
    const { name, value, type, checked } = e.target;
    setSearch((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [name]: type === "checkbox" ? checked : value,
      },
      page: 1,
    }));
  };

  // Réinitialiser les filtres
  const resetFilters = () => {
    setSearch(initialSearchState);
  };

  // Définir des filtres programmatiquement
  const setSearchFilters = (filters) => {
    const newSearch = {
      ...search,
      filters: {
        ...search.filters,
        ...filters,
      },
      page: 1,
    };
    setSearch(newSearch);
    return newSearch;
  };

  // Changer de page
  const changePage = (page) => {
    searchInvitations(page);
    setSearch((prev) => ({ ...prev, page }));
  };

  // Changer le nombre d'items par page
  const changeNbItemsByPage = (nbItemsByPage) => {
    searchInvitations(false, nbItemsByPage);
    setSearch((prev) => ({ ...prev, nbItemsByPage }));
  };

  return {
    invitations,
    search,
    isLoading,
    nbPages,
    nbResults,
    hasSearched,
    searchInvitations,
    updateSearch,
    resetFilters,
    changePage,
    changeNbItemsByPage,
    setSearchFilters,
  };
};

export default useRDOInviteList;
